// extracted by mini-css-extract-plugin
module.exports = {"home":"Branches_home__2TO0O","textFields":"Branches_textFields__gNoLS","actionButton":"Branches_actionButton__2rTs4","error":"Branches_error__GVJn6","flex":"Branches_flex__1ow4_"};